{
  "fr": {
    "sales": {
      "actions": {
        "assign_lead": "Attribuer un prospect",
        "remove_lead_from_deal": "Supprimer le prospect de la transaction",
        "update_status": "État de mise à jour",
        "upload_document": "Télécharger un document"
      },
      "attributes": {
        "status": "Statut"
      },
      "labels": {
        "assign_customer": "Attribuer un client",
        "assign_lead_to_unit": "Affecter le prospect à l'unité",
        "assigned_by": "Assigné par",
        "contracts": "Contrats",
        "expiry_date": "Date d'expiration de la réservation",
        "go_to_unit_part_1": "Cette unité a été vendue. Si vous souhaitez mettre à jour le statut, vous devez vous rendre sur le",
        "go_to_unit_part_2": "et désaffecter d'abord le client par mesure de sécurité.",
        "interested_leads": "{count} prospects intéressés",
        "internal_note": "Remarque interne",
        "latest_phase": " Phase actuelle",
        "lead_existing": "Prospect existant",
        "lead_new": "Nouveau prospect",
        "mark_as_sold": "Marquer comme vendu",
        "not_published_sales_partners": "Non publié pour les partenaires commerciaux",
        "not_shown_interest": "Ce prospect n'a montré d'intérêt pour aucune unité",
        "note_explainer": "Cette note n'est visible que pour votre équipe",
        "publish_unit": "Publier 1 unité pour tous les partenaires commerciaux | Publier {count} unités pour tous les partenaires commerciaux",
        "published_sales_partners": "Publié pour les partenaires commerciaux",
        "reserved_by": "Réservé par",
        "reserved_warning": "Cette unité est actuellement réservée par {lead_name}. Si vous marquez cet appareil comme vendu, cette réservation sera annulée.",
        "sales": "Vente",
        "selling_price": "Prix de vente",
        "sold_date": "Vendu à",
        "sorting": {
          "deal_lead_group_name": "Prospect",
          "deal_status": "Statut",
          "name": "Nom de l'unité"
        },
        "status": "Statut",
        "statuses": {
          "available": "Disponible",
          "interested": "Intéressé",
          "lost": "Perdu",
          "reserved": "Réservé",
          "sold": "Vendu"
        },
        "tab_sales_documents": "Documents",
        "tab_sales_tickets": "Conversations",
        "tab_sales_units": "Unités",
        "unit": "Unité",
        "unit_information_page": "page d'informations sur l'unité",
        "unit_sales_status_header": "Cette unité est à vendre",
        "unpublish_unit": "Unublish 1 unité pour tous les partenaires commerciaux | Annuler la publication de {count} unités pour tous les partenaires commerciaux",
        "update_sales_status": "Mettre à jour le statut des ventes unitaires",
        "upload_sales_doc": "Télécharger le document de vente"
      },
      "validation": {
        "already_reserved_sold": "Cette unité est déjà réservée ou vendue à un autre prospect !",
        "already_reserved_sold_info": "Si vous êtes sûr de vouloir modifier le statut du prospect actuel, vous devez d'abord modifier le statut de la transaction actuellement prioritaire. Une fois que vous avez modifié le statut de l'autre offre, vous pouvez revenir en arrière et mettre à jour le statut en toute sécurité.",
        "need_sold_date": "Besoin de la date de cette vente",
        "reserved_expiry_date": "Besoin d'une date d'expiration pour cette réservation"
      }
    }
  }
}